module.exports = __webpack_public_path__ + "img/left3.9b99c2dd.png";